
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"fill":"currentColor"},style,staticStyle],
              attrs: Object.assign({"style":"fill: currentColor;","viewBox":"0 0 96 96","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Icons-/-System-/-Generic-/-sad-cloud","stroke":"none","stroke-width":"1","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M56,16 C71.463973,16 84,28.536027 84,44 C84,44.3406117 83.9939181,44.6798029 83.9818571,45.0174709 C90.9822156,47.4833604 96,54.155697 96,62 C96,71.8306685 88.1192167,79.8206815 78.3306652,79.9970237 L78,80 L18,80 C8.0588745,80 0,71.9411255 0,62 C0,54.0526782 5.15044642,47.3083077 12.2955583,44.9226693 C13.7304703,37.5583765 20.216121,32 28,32 C28.8842148,32 29.7516773,32.0717251 30.5968867,32.2096746 C35.0458304,22.6373171 44.747801,16 56,16 Z M49.5,58 C42.3289274,58 35.749723,61.0076363 29.8786797,66.8786797 C28.7071068,68.0502525 28.7071068,69.9497475 29.8786797,71.1213203 C31.0502525,72.2928932 32.9497475,72.2928932 34.1213203,71.1213203 C38.9169436,66.3256971 44.0044059,64 49.5,64 C54.9955941,64 60.0830564,66.3256971 64.8786797,71.1213203 C66.0502525,72.2928932 67.9497475,72.2928932 69.1213203,71.1213203 C70.2928932,69.9497475 70.2928932,68.0502525 69.1213203,66.8786797 C63.250277,61.0076363 56.6710726,58 49.5,58 Z M37,41 C34.2385763,41 32,43.2385763 32,46 C32,48.7614237 34.2385763,51 37,51 C39.7614237,51 42,48.7614237 42,46 C42,43.2385763 39.7614237,41 37,41 Z M63,41 C60.2385763,41 58,43.2385763 58,46 C58,48.7614237 60.2385763,51 63,51 C65.7614237,51 68,48.7614237 68,46 C68,43.2385763 65.7614237,41 63,41 Z","id":"Shape"}})])])
          )
        }
      }
    